export const CHEKOUT_SUMMARY_DATA_QUERY_KEY = 'checkout-summary-data';
export const PAYMENT_PROFILE_QUERY_KEY = 'payment-profile-query-key';
